import React from "react";
import { useTranslation } from "react-i18next";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { JPInputErrorProps } from "./jpInputError.model";
import "@companion-core/web/src/Assets/Styles/scss/inputerror.scss";

export const JPInputError: React.FC<JPInputErrorProps> = ({
  error,
  testID,
  position = "bottom",
  inputLabel,
  id,
}: JPInputErrorProps) => {
  const { t } = useTranslation();
  const errorText = t(`${error}.text`);
  const ariaErrorText = inputLabel
    ? t(`${error}.label`, {
        label: inputLabel,
        error: errorText,
        interpolation: { escapeValue: false },
      })
    : errorText;
  return (
    <div
      id={id}
      role="alert"
      aria-label={ariaErrorText}
      aria-live="polite"
      data-testid={testID ? `${testID}--error` : undefined}
      className={`JPInputError ${position === "top" ? "JPInputError--top" : null}`}>
      <FontIcon
        aria-hidden={true}
        data-testid={testID ? `${testID}--error-icon` : undefined}
        name="JP-Info"
        size={20}
        className="JPInputError__icon-error"
      />
      <span aria-hidden={true} className="body-text-8">
        {errorText}
      </span>
    </div>
  );
};
